export const characters = {
  PEACEMAKER: {
    id: "PEACEMAKER",
    name: "PEACEMAKER",
    selected: require("../assets/characters/selected/peacemaker.png").default,
    deselected: require("../assets/characters/deselected/peacemaker.png")
      .default,
    icon: require("../assets/characters/icons/peacemaker.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-peacemaker.png").default,
    shareIcon: require("../assets/share/icons/peacemaker.png").default,
  },
  KING_SHARK: {
    id: "KING_SHARK",
    name: "KING SHARK",
    selected: require("../assets/characters/selected/king-shark.png").default,
    deselected: require("../assets/characters/deselected/king-shark.png")
      .default,
    icon: require("../assets/characters/icons/king-shark.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-king-shark.png").default,
    shareIcon: require("../assets/share/icons/king-shark.png").default,
  },
  WEASEL: {
    id: "WEASEL",
    name: "WEASEL",
    selected: require("../assets/characters/selected/weasel.png").default,
    deselected: require("../assets/characters/deselected/weasel.png").default,
    icon: require("../assets/characters/icons/weasel.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-weasel.png").default,
    shareIcon: require("../assets/share/icons/weasel.png").default,
  },
  CPT_BOOMERANG: {
    id: "CPT_BOOMERANG",
    name: "CPT BOOMERANG",
    selected: require("../assets/characters/selected/cpt-boomerang.png")
      .default,
    deselected: require("../assets/characters/deselected/cpt-boomerang.png")
      .default,
    icon: require("../assets/characters/icons/cpt-boomerang.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-cpt-boomerang.png").default,
    shareIcon: require("../assets/share/icons/cpt-boomerang.png").default,
  },
  RICK_FLAG: {
    id: "RICK_FLAG",
    name: "RICK FLAG",
    selected: require("../assets/characters/selected/rick-flag.png").default,
    deselected: require("../assets/characters/deselected/rick-flag.png")
      .default,
    icon: require("../assets/characters/icons/rick-flag.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-rick-flag.png").default,
    shareIcon: require("../assets/share/icons/rick-flag.png").default,
  },
  RATCATCHER_II: {
    id: "RATCATCHER_II",
    name: "RATCATCHER II",
    selected: require("../assets/characters/selected/ratcatcher-ii.png")
      .default,
    deselected: require("../assets/characters/deselected/ratcatcher-ii.png")
      .default,
    icon: require("../assets/characters/icons/ratcatcher-ii.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-ratcatcher-ii.png").default,
    shareIcon: require("../assets/share/icons/ratcatcher-ii.png").default,
  },
  TDK: {
    id: "TDK",
    name: "TDK",
    selected: require("../assets/characters/selected/tdk.png").default,
    deselected: require("../assets/characters/deselected/tdk.png").default,
    icon: require("../assets/characters/icons/tdk.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-tdk.png").default,
    shareIcon: require("../assets/share/icons/tdk.png").default,
  },
  BLOODSPORT: {
    id: "BLOODSPORT",
    name: "BLOODSPORT",
    selected: require("../assets/characters/selected/bloodsport.png").default,
    deselected: require("../assets/characters/deselected/bloodsport.png")
      .default,
    icon: require("../assets/characters/icons/bloodsport.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-bloodsport.png").default,
    shareIcon: require("../assets/share/icons/bloodsport.png").default,
  },
  HARLEY_QUINN: {
    id: "HARLEY_QUINN",
    name: "HARLEY QUINN",
    selected: require("../assets/characters/selected/harley-quinn.png").default,
    deselected: require("../assets/characters/deselected/harley-quinn.png")
      .default,
    icon: require("../assets/characters/icons/harley-quinn.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-harley-quinn.png").default,
    shareIcon: require("../assets/share/icons/harley-quinn.png").default,
  },
  JAVELIN: {
    id: "JAVELIN",
    name: "JAVELIN",
    selected: require("../assets/characters/selected/javelin.png").default,
    deselected: require("../assets/characters/deselected/javelin.png").default,
    icon: require("../assets/characters/icons/javelin.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-javelin.png").default,
    shareIcon: require("../assets/share/icons/javelin.png").default,
  },
  MONGAL: {
    id: "MONGAL",
    name: "MONGAL",
    selected: require("../assets/characters/selected/mongal.png").default,
    deselected: require("../assets/characters/deselected/mongal.png").default,
    icon: require("../assets/characters/icons/mongal.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-mongal.png").default,
    shareIcon: require("../assets/share/icons/mongal.png").default,
  },
  POLKA_DOT_MAN: {
    id: "POLKA_DOT_MAN",
    name: "POLKA DOT MAN",
    selected: require("../assets/characters/selected/polka-dot-man.png")
      .default,
    deselected: require("../assets/characters/deselected/polka-dot-man.png")
      .default,
    icon: require("../assets/characters/icons/polka-dot-man.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-polka-dot-man.png").default,
    shareIcon: require("../assets/share/icons/polka-dot-man.png").default,
  },
  BLACKGUARD: {
    id: "BLACKGUARD",
    name: "BLACKGUARD",
    selected: require("../assets/characters/selected/blackguard.png").default,
    deselected: require("../assets/characters/deselected/blackguard.png")
      .default,
    icon: require("../assets/characters/icons/blackguard.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-blackguard.png").default,
    shareIcon: require("../assets/share/icons/blackguard.png").default,
  },
  SAVANT: {
    id: "SAVANT",
    name: "SAVANT",
    selected: require("../assets/characters/selected/savant.png").default,
    deselected: require("../assets/characters/deselected/savant.png").default,
    icon: require("../assets/characters/icons/savant.png").default,
    scoreIcon: require("../assets/characters/score-icons/score-savant.png").default,
    shareIcon: require("../assets/share/icons/savant.png").default,
  },
};
